exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-body{margin-top:50px}.post-body p.p1{margin:30px 0}.post-body blockquote{margin:50px 0;font-size:18px}.post-body img{width:100%;height:auto;margin:25px 0 50px}", ""]);

// exports
